import Vue from "vue";

function initialState() {
  return {};
}

const state = initialState();

const actions = {
  getAssingmentSettings: async function(context, request) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "get",
      "/api/edit_contact_user_assignments/dealer_settings/" +
        request +
        "/get_contact_user_assignment_dealer_settings"
    ).catch(err => err.response);
    return response && response.data && response.data.successful
      ? response.data.data
      : null;
  },

  saveAssignmentSettings: async function(context, payload) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "post",
      "/api/edit_contact_user_assignments/dealer_settings/save_contact_user_assignment_dealer_settings",
      payload
    ).catch(err => err.response);
    return response && response.data && response.data.successful
      ? response.data.successful
      : null;
  }
};

const mutations = {};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/AssignmentSettings.js